import { type ReactElement } from "react"
import commentAndReactVertical2x from "~/images/landing/comment-and-react-vertical@2x.png"
import commentAndReactVertical3x from "~/images/landing/comment-and-react-vertical@3x.png"
import commentAndReactHorizontal4x from "~/images/landing/comment-and-react-horizontal@4x.png"
import { ResponsiveImage, BREAKPOINTS } from "../common/responsive-image"

function CommentAndReactImageHorizontal(): ReactElement {
  return (
    <ResponsiveImage
      sources={[{ media: BREAKPOINTS.desktop, src: commentAndReactHorizontal4x }]}
      fallbackSrc={commentAndReactHorizontal4x}
      alt="Comment and react"
      className="hidden md:block"
    />
  )
}

function CommentAndReactImageVertical(): ReactElement {
  return (
    <ResponsiveImage
      sources={[
        { media: BREAKPOINTS.mobile, src: commentAndReactVertical2x },
        { media: BREAKPOINTS.tablet, src: commentAndReactVertical3x },
      ]}
      fallbackSrc={commentAndReactVertical3x}
      alt="Comment and react"
      className="block md:hidden"
    />
  )
}

export function CommentAndReactImage() {
  return (
    <>
      <CommentAndReactImageHorizontal />
      <CommentAndReactImageVertical />
    </>
  )
}
